<template>
    <div class="TicketLoadList">
        <div v-if="true">
            <div class="header">
                <div class="column">#</div>
                <div class="column">Load</div>
                <div class="column">Dump</div>
                <div class="column">Tons</div>
                <div class="column">Files</div>
                <div class="column"></div>
            </div>
            <div class="main">
                <TicketLoadItem
                    v-for="(load, index) in loads"
                    :key="load.number"
                    :load="load"
                    @edit="handleEditLoad(index, load)"
                    @remove="handleRemoveLoad(load)"
                />
            </div>
        </div>

        <Button class="outline" @click="handleAddLoad">Add Load</Button>
    </div>
</template>

<script>
import ConfirmModal from '@/components/modals/ConfirmModal';
import TicketLoadFormModal from './TicketLoadFormModal';
import TicketLoadItem from './TicketLoadItem';

export default {
    name: 'TicketLoadList',

    components: { TicketLoadFormModal, TicketLoadItem },

    props: {
        loads: { type: Array, default: [] },
    },

    methods: {
        handleAddLoad() {
            const previousLoad = this.loads.length <= 1 ? this.loads[this.loads.length - 1] : null;

            const load = {
                number: this.loads.length + 1,
                loadSiteArriveAt: null,
                loadSiteLeaveAt: null,
                dumpSiteArriveAt: null,
                dumpSiteLeaveAt: null,
                standbyStartAt: null,
                standbyEndAt: null,
                tons: null,
                material: null,
                isBackhaul: false,
                scaleTicketCode: null,
                notes: null,
            };

            const onSubmit = (load) => {
                this.updateLoads([...this.loads, load]);
            }

            this.$modal.show(TicketLoadFormModal,
                { load, previousLoad, onSubmit },
                { height: 'auto', scrollable: true }
            );
        },

        handleEditLoad(index, load) {
            const modalOnSubmit = (newLoad) => {
                // Replace the load in the array with the new load
                const loads = this.loads.map(load => {
                    return load.number === newLoad.number ? newLoad : load;
                });

                this.updateLoads(loads);
            }


            const previousLoad = this.loads.length <= 1 ? this.loads[index - 1] : null;

            this.$modal.show(TicketLoadFormModal,
                { load, previousLoad, onSubmit: modalOnSubmit, isEditMode: true },
                { height: 'auto', scrollable: true },
            );
        },

        handleRemoveLoad(load) {
            const onConfirm = () => {
                const loads = this.loads.filter((l) => l.number !== load.number);
                this.updateLoads(loads);
            }

            const title = 'Delete Confirmation';
            const message = 'Are you sure you want to delete this load?'
            this.$modal.show(ConfirmModal,
                { title, message, type: 'delete', confirmLabel: 'Delete', onConfirm },
                { height: 'auto' },
            );
        },

        updateLoads(loads) {
            this.$emit('update:loads', loads);
            this.$emit('change', loads);
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.TicketLoadList {
    .header {
        display: flex;
        padding: $grid-gutter-width;
        padding-top: 0;

        .column {
            @extend %ticket-load-column;
            font-weight: $font-weight-bold;
        }
    }

    .main {
        min-height: 55px;
        border-radius: $border-radius;
        border: 1px solid $divider-color;
        margin-bottom: $grid-gutter-width;
    }

    .Button {
        display: block;
        margin-left: auto;
    }
}
</style>
